import React from "react";
import { formatData } from "@/shared/FunctionCore";

const AssetsTable = ({ props }) => {
  return (
    <>
      <table>
        <thead>
          <th className="statement_name th" scope="col">
            Assets (MIL)
          </th>
          {props.assets.assetsYear.map((assetyear) => (
            <>
              <th className="statement_year th" scope="col">
                {assetyear}
              </th>
            </>
          ))}
        </thead>
        <tbody>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Current Assets
            </th>
            {props.assets.cash.map((cash) => (
              <>
                <td className="statement_year th" scope="col"></td>
              </>
            ))}
          </tr>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Cash and Cash Equivalents
            </th>
            {props.assets.cash.map((cash) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(cash)}
                </td>
              </>
            ))}
          </tr>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Accounts Receivable
            </th>
            {props.assets.netReceivables.map((netReceivables) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(netReceivables)}
                </td>
              </>
            ))}
          </tr>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Inventories
            </th>
            {props.assets.inventories.map((inventories) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(inventories)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Other Current Assets
            </th>
            {props.assets.otherIncomeAssets.map((otherIncomeAssets) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(otherIncomeAssets)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Asset Summary
            </th>
            {props.assets.cash.map((netFixedAsset) => (
              <>
                <td className="statement_year th" scope="col"></td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Total Current Assets
            </th>
            {props.assets.totalCurrentAssets.map((totalCurrentAssets) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(totalCurrentAssets)}
                </td>
              </>
            ))}
          </tr>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Tangible Fixed Assets
            </th>
            {props.assets.netFixedAssets.map((netFixedAssets) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(netFixedAssets)}
                </td>
              </>
            ))}
          </tr>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Intangible Assets
            </th>
            {props.assets.otherIntangibleAssets.map((otherIntangibleAssets) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(otherIntangibleAssets)}
                </td>
              </>
            ))}
          </tr>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Total Assets
            </th>
            {props.assets.totalAssets.map((totalAssets) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(totalAssets)}
                </td>
              </>
            ))}
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default AssetsTable;
